import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [{
		path: '',
		name:'home',
		component: Home,
	},
	{
		path: '/login',
		nameL:'login',
		component: () => import('@/views/login.vue')
	},
	{
		path: '/document',
		name:'document',
		component: () => import('@/views/document.vue')
	},
	{
		path: '/apply',
		name:'apply',
		component: () => import('@/views/apply.vue')
	},
	{
		path: '/regist',
		name:'regist',
		component: () => import('@/views/regist.vue')
	},
	{
		path: '/test',
		name:'test',
		component: () => import('@/views/test.vue')
	}
]

const router = new VueRouter({
	// mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
